import { MoveWareHouseHeaderKey, TableContentHeaderKey, UnmanagedBusinessHeaderKey } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import { BaseTableContentViewModel } from '../../baseTableContentViewModel';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { i18n } from '@/i18n';
import { IParentBusinessWithMoveWarehouse } from '@/InventoryControlModule/domains/entities/Business';

/**
 *　置場移動取引のテーブル表示に使うロジック
 */
export class MoveWarehouseTableContentViewModel extends BaseTableContentViewModel {
  /**
   * 置場移動の項目表示用
   * @param headerKey - ヘッダーキー
   * @param item - テーブルコンテンツアイテム
   */
  public displayOrderItem = (headerKey: MoveWareHouseHeaderKey, item: TableContentItem): string => {
    const business = item as IParentBusinessWithMoveWarehouse;
    switch (headerKey) {
      case 'differenceOccurrenceMonthYear':
        return DateService.convertIYearMonthToYYYYMMWithSlash(business.differenceOccurrenceMonthYear);
      default:
        return `${business[headerKey]}`;
    }
  };

  /**
   * ヘッダーキーがannounceの場合、対応する年月の文字列を返す
   * @param headerKey - ヘッダーキー
   */
  public getAnnounceYearMonth = (headerKey: TableContentHeaderKey): string => {
    const t = i18n.t;
    switch (headerKey) {
      case 'customerAnnounce-1':
        const now = new Date();
        now.setDate(1);
        now.setMonth(now.getMonth());
        return `${t('内示')} ${DateService.convertIYearMonthToYYYYMMWithSlash(DateService.convertDateToIYearMonth(now))}`;
      case 'customerAnnounce-2':
        const now2 = new Date();
        now2.setDate(1);
        now2.setMonth(now2.getMonth() + 1);
        return `${t('内示')} ${DateService.convertIYearMonthToYYYYMMWithSlash(DateService.convertDateToIYearMonth(now2))}`;
      case 'customerAnnounce-3':
        const now3 = new Date();
        now3.setDate(1);
        now3.setMonth(now3.getMonth() + 2);
        return `${t('内示')} ${DateService.convertIYearMonthToYYYYMMWithSlash(DateService.convertDateToIYearMonth(now3))}`;
      default:
        return `${t(headerKey)}`;
    }
  };
}
